import type { CSSProperties } from 'react';

import './Skeleton.css';

export interface SkeletonProps {
  /** CSS inline size, e.g. "8rem" or "60%". */
  width?: string;
  /** CSS block size; defaults to one line of body text. */
  height?: string;
  /** How many stacked lines to draw. */
  lines?: number;
  shape?: 'text' | 'block' | 'circle';
}

/**
 * Skeleton is the placeholder for content whose shape is known. It is
 * decorative: the region it sits in should carry aria-busy, which DataTable
 * and StatTile do for you.
 */
export function Skeleton({ width, height, lines = 1, shape = 'text' }: SkeletonProps) {
  const style: CSSProperties = {
    ...(width ? { inlineSize: width } : {}),
    ...(height ? { blockSize: height } : {}),
  };
  if (lines === 1) {
    return <span className="rs-skeleton" data-shape={shape} style={style} aria-hidden="true" />;
  }
  return (
    <span className="rs-skeleton-lines" aria-hidden="true">
      {Array.from({ length: lines }, (_, line) => (
        <span
          key={`line-${String(line)}`}
          className="rs-skeleton"
          data-shape={shape}
          // The last line is shorter, as the end of a paragraph is.
          style={line === lines - 1 ? { ...style, inlineSize: '60%' } : style}
        />
      ))}
    </span>
  );
}
